module.exports = __webpack_public_path__ + "img/wk-product-1-1x.63f0cdab.png";